import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";

import Grid from "../../components/Grid";
import { TextInput } from "../../components/Form";

export default function SaleObjFilterMiddle({
  jianpingStart,
  onChangeJianpingStart = () => { },
  jianpingEnd,
  onChangeJianpingEnd = () => { },
  floorStart,
  onChangeFloorStart = () => { },
  floorEnd,
  onChangeFloorEnd = () => { },
  unitPriceJianpingStart,
  onChangeUnitPriceJianpingStart = () => { },
  unitPriceJianpingEnd,
  onChangeUnitPriceJianpingEnd = () => { },
  unitPriceFloorStart,
  onChangeUnitPriceFloorStart = () => { },
  unitPriceFloorEnd,
  onChangeUnitPriceFloorEnd = () => { },
  basePriceStart,
  onChangeBasePriceStart = () => { },
  basePriceEnd,
  onChangeBasePriceEnd = () => { },
}) {
  const useStyles = makeStyles({
    DocumentContainerEnd: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "flex-end",
    },
  });
  const classes = useStyles();
  const fieldStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '25ch',
      },
    },
  }));
  const fieldClasses = fieldStyles();
  return (
    <Box padding={1} width="100%" style={{ backgroundColor: "white" }}>
      <Grid container spacing={1}>
        <Grid container item spacing={1}>
          <Grid item xs={6} sm={3}>
            <Box display="flex" flexDirection="row" alignItems="flex-end">
              <Box display="flex" flexDirection="column">
                <Typography color="primary" style={{ fontSize: 14 }}>建坪</Typography>
                <TextInput
                  value={jianpingStart}
                  onChange={(v) => onChangeJianpingStart(v)}
                  fullWidth
                />
              </Box>
              <Typography color="primary">～</Typography>
              <Grid item classes={{ root: classes.DocumentContainerEnd }}>
                <Typography color="primary" style={{ fontSize: 14 }}>坪</Typography>
                <TextInput
                  value={jianpingEnd}
                  onChange={(v) => onChangeJianpingEnd(v)}
                  fullWidth
                />
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box display="flex" flexDirection="row" alignItems="flex-end">
              <Box display="flex" flexDirection="column">
                <Typography color="primary" style={{ fontSize: 14 }}>地坪</Typography>
                <TextInput
                  value={floorStart}
                  onChange={(v) => onChangeFloorStart(v)}
                  fullWidth
                />
              </Box>
              <Typography color="primary">～</Typography>
              <Grid item classes={{ root: classes.DocumentContainerEnd }}>
                <Typography color="primary" style={{ fontSize: 14 }}>坪</Typography>
                <TextInput
                  value={floorEnd}
                  onChange={(v) => onChangeFloorEnd(v)}
                  fullWidth
                />
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Grid container item spacing={1}>
          <Grid item xs={6} sm={3}>
            <Box display="flex" flexDirection="row" alignItems="flex-end">
              <Box display="flex" flexDirection="column">
              <Typography color="primary" style={{ fontSize: 14 }}>建坪單價</Typography>
                <TextInput
                  value={unitPriceJianpingStart}
                  onChange={(v) => onChangeUnitPriceJianpingStart(v)}
                  fullWidth
                />
              </Box>
              <Typography color="primary">～</Typography>
              <Grid item classes={{ root: classes.DocumentContainerEnd }}>
              <Typography color="primary" style={{ fontSize: 14 }}>萬</Typography>
                <TextInput
                  value={unitPriceJianpingEnd}
                  onChange={(v) => onChangeUnitPriceJianpingEnd(v)}
                  fullWidth
                />
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Box display="flex" flexDirection="row" alignItems="flex-end">
              <Box display="flex" flexDirection="column">
              <Typography color="primary" style={{ fontSize: 14 }}>地坪單價</Typography>
                <TextInput
                  value={unitPriceFloorStart}
                  onChange={(v) => onChangeUnitPriceFloorStart(v)}
                  fullWidth
                />
              </Box>
              <Typography color="primary">～</Typography>
              <Grid item classes={{ root: classes.DocumentContainerEnd }}>
              <Typography color="primary" style={{ fontSize: 14 }}>萬</Typography>
                <TextInput
                  value={unitPriceFloorEnd}
                  onChange={(v) => onChangeUnitPriceFloorEnd(v)}
                  fullWidth
                />
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Grid container item spacing={1}>
          <Grid item xs={6} sm={3}>
            <Box display="flex" flexDirection="row" alignItems="flex-end">
              <Box display="flex" flexDirection="column">
              <Typography color="primary" style={{ fontSize: 14 }}>底標價</Typography>
                <TextInput
                  value={basePriceStart}
                  onChange={(v) => onChangeBasePriceStart(v)}
                  fullWidth
                />
              </Box>
              <Typography color="primary">～</Typography>
              <Grid item classes={{ root: classes.DocumentContainerEnd }}>
              <Typography color="primary" style={{ fontSize: 14 }}>萬</Typography>
                <TextInput
                  value={basePriceEnd}
                  onChange={(v) => onChangeBasePriceEnd(v)}
                  fullWidth
                />
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
